module.exports = __webpack_public_path__ + "static/media/nynfc10.a6db0134.jpg";